import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { LayoutUser } from '@sagano/share/components';
import adminAuth from '@sagano/admin/vendors/firebase';
import { useStore } from '@sagano/admin/stores';

const UserView = () => {
  const { auth } = useStore();

  const logout = useCallback(() => {
    adminAuth.logout();
  }, []);

  return <LayoutUser auth={auth} onLogout={logout} />;
};

const User = observer(UserView);

export default User;
